'use strict';

import Vue from 'vue';
import urls from './urls';
import config from './config';
import VueRouter from 'vue-router';
import VueDragAndDropList from 'vue-drag-and-drop-list';

if (config.DEBUG_MODE) {
    Vue.config.debug = true;
}

Vue.use(VueRouter);
Vue.use(VueDragAndDropList);

const router = new VueRouter({
    history: true,
    saveScrollPosition: true
});
urls.init(router);

export default router;



// WEBPACK FOOTER //
// ./src/router.js